import { Component  } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataShareService } from './shared/data-share.service';

@Component({
  selector: 'app-landing-layout',
  templateUrl: './landing-layout.component.html',
  styleUrls: ['./landing-layout.component.css']
})
export class LandingLayoutComponent {

  hostName: any = '';
  host: any = '';
  public currentPage: any;
  public displayLogin: boolean = false

  constructor(private router: Router, private spinner: NgxSpinnerService,private dataShare: DataShareService) {
    // this.currentPage = `/${(this.router.url).split('/')[1]}`;
    // if (this.hostName !== 'www.ownlytrade.com.au' && this.currentPage !== '/#!') {
    //   console.log('if => ');
    //   this.router.navigate(['/trade']);
    // } else {
    //   console.log('else => ');
    //   this.router.navigate(['']);
    // }
    this.dataShare.isOpenSignIn.subscribe(data => {
      this.displayLogin = data
    })
  }

}
